export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";